import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { MaterialCard } from "@/components/marketing/MaterialCard";

export const PreviewDialog = ({ item, onClose }) => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/admin/marketing/contents/${item.id}/preview`).then((r) => setData(r.data)); }, [item.id]);

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" data-testid="preview-dialog">
      <div className="bg-[#F5F5F5] rounded-[12px] w-full max-w-3xl max-h-[85vh] overflow-y-auto p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold text-[#0A0A0A]">Anteprima come la vede il PA</h3>
          <button onClick={onClose} data-testid="preview-close"><X size={18} /></button>
        </div>
        {!data ? <p className="text-gray-400 text-sm">Caricamento…</p> : (
          <>
            <p className="text-xs text-gray-500">Link usato per l'anteprima: <span className="font-mono" data-testid="preview-link">{data.link}</span></p>
            <MaterialCard item={data.item} assetBase="/admin/marketing/assets" defaultOpen />
            <div className="vg-card p-4">
              <p className="text-xs font-bold uppercase tracking-wide text-gray-500 mb-2">Email di notifica · {data.email.subject}</p>
              <iframe title="email" srcDoc={data.email.html} className="w-full h-[380px] bg-white rounded-[8px] border border-gray-100" data-testid="preview-email" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
